import algoliasearch from 'algoliasearch/lite';

const appId = process.env.REACT_APP_ALGOLIA_APP_ID;
const searchKey = process.env.REACT_APP_ALGOLIA_SEARCH_KEY;

console.log('Algolia credentials:', {
  appId,
  searchKey: searchKey?.substring(0, 10) + '...',
  configured: !!(appId && searchKey)
});

// Create a search client with proper error handling
export const searchClient = appId && searchKey
  ? algoliasearch(appId, searchKey)
  : {
      search: () => Promise.resolve({ results: [] }),
      searchForFacetValues: () => Promise.resolve([]),
    };

export const HELP_ARTICLES_INDEX = 'help_articles';

export const isAlgoliaConfigured = () => {
  return !!(appId && searchKey);
};
